import qs from 'qs';
import axios from './axios'

function service(endpoint) {

    function fetchProfile() {
        return axios.get(endpoint).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchAll(params) {
        return axios.get(endpoint, {
            params: params,
            paramsSerializer: query => qs.stringify(query, {encode: false})
        }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchEvents(params) {
        return axios.get(`${endpoint}/events`, {
            params: params,
            paramsSerializer: query => qs.stringify(query, {encode: false})
        }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchRewards(params) {
        return axios.get(`${endpoint}/rewards`, {
            params: params,
            paramsSerializer: query => qs.stringify(query, {encode: false})
        }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function reportEvent(payload) {
        return axios.post(`${endpoint}/events`, payload).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchProfile,
        fetchAll,
        fetchEvents,
        fetchRewards,
        reportEvent
    }
}

export default service
